<!-- Import SCSS boilerplate -->
<style src="../assets/css/styles.scss" lang="scss"></style>
<script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/2.0.1/TweenMax.min.js"></script>

<template>
    <div class="styleguide">
        <div class="row">
            <div class="col-12">
                <h1>Styleguide</h1>
            </div>
        </div>


        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2><i class="panel__header__icon icons icon-fire"></i>Teksten</h2>
                    </div>
                    <div class="panel__body">
                        <h1>This is an H1 text</h1>
                        <h2>This is an H2 text</h2>
                        <h3>This is an H3 text</h3>
                        <h3 class="purple">This is a purple H3 text</h3>
                        <p>This is a short text to present what some standard, <strong>bold</strong> and <i>italic</i> text would look like.</p>
                        <p class="success">This is a succes message/status</p>
                        <p class="error">This is an error message/status</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2><i class="panel__header__icon icons icon-people"></i>Buttons</h2>
                    </div>

                    <div class="panel__body">
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 col-md-3">
                                <a href="#" class="button--cta">Button CTA</a>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-3">
                                <a href="#" class="button">Button</a>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-3">
                                <a href="#" class="button--alt">Button ALT</a>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-3">
                                <a href="#" class="button--cta disabled" disabled>Button Disabled</a>
                            </div>

                            <!-- button that transforms into spinner -->
                            <div class="col-xs-12 col-sm-6 col-md-3">
                                <loading-button text="Opslaan"/>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="panel--expand">
                    <div class="panel__header">
                        <h2><i class="panel__header__icon icons icon-arrow-up-circle"></i>Expandable panel</h2>
                    </div>

                    <div class="panel__body" :class="{expanded}">
                        <div class="row">
                            <div class="col-xs-12">
                                <p>This panel can be expanded if there are too many items taking up space.</p>
                                <p>This panel can be expanded if there are too many items taking up space.</p>
                                <p>This panel can be expanded if there are too many items taking up space.</p>
                                <p>This panel can be expanded if there are too many items taking up space.</p>
                                <p>This panel can be expanded if there are too many items taking up space.</p>
                                <p>This panel can be expanded if there are too many items taking up space.</p>
                                <p>This panel can be expanded if there are too many items taking up space.</p>
                                <p>This panel can be expanded if there are too many items taking up space.</p>

                            </div>
                        </div>
                    </div>

                    <div class="panel__btn-expand" @click="togglePanelExpansion">
                        <div v-if="expanded"><i class="icons icon-arrow-down"></i>See more</div>
                        <div v-else><i class="icons icon-arrow-up"></i>See less</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2><i class="panel__header__icon icons icon-people"></i>Links</h2>
                    </div>

                    <div class="panel__body">
                        <a href="#" class="button--link">Link</a>
                        <a href="#" class="button--link--cta">Link CTA</a>
                        <a href="#" class="button--link disabled" disabled>Link Disabled</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2>Spinner</h2>
                    </div>
                    <div class="panel__body">
                        <div class="styleguide__item">
                            <div class="spinner"></div>
                        </div>
                        <div class="styleguide__item">
                            <div class="spinner--small"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2>Alerts</h2>
                    </div>
                    <div class="panel__body">
                        <div class="row">
                            <div class="col-12 col-md-8 col-lg-6">
                                <div class="styleguide__item">
                                    <div class="alert">This is a normal information alert!</div>
                                </div>
                                <div class="styleguide__item">
                                    <div class="alert--success">This is a success alert!</div>
                                </div>
                                <div class="styleguide__item">
                                    <div class="alert--error">This is an error alert</div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2><i class="panel__header__icon icons icon-doc"></i>Forms</h2>
                    </div>
                    <div class="panel__body">
                        <form class="form">
                            <fieldset class="form__fieldset">
                            <div class="row">
                                <div class="col-12 col-sm-8 col-md-6">

                                    <!-- RADIO BUTTONS -->
                                    <div class="form__item--radio">
                                        <p>This is a nice explanation about the radio buttons below, that the user has to click. Cool, right.</p>
                                        <div class="form__radio">
                                            <input type="radio" name="radio_styled" id="radio_styled1" class="form__radio__input" value="man" checked />
                                            <label class="form__radio__label" htmlFor="radio_styled1">Man</label>
                                        </div>
                                        <div class="form__radio">
                                            <input type="radio" name="radio_styled" id="radio_styled2" class="form__radio__input" value="woman"  />
                                            <label class="form__radio__label" htmlFor="radio_styled2">Vrouw</label>
                                        </div>
                                        <div class="form__radio">
                                            <input type="radio" name="radio_styled" id="radio_styled3" class="form__radio__input" value="different"  />
                                            <label class="form__radio__label" htmlFor="radio_styled3">Anders</label>
                                        </div>
                                    </div>

                                    <!-- CHECKBOX -->
                                    <div class="form__checkboxes">
                                        <label class="form__top_label">Checkboxes</label>
                                        <div class="form__item--checkbox">
                                            <div class="form__checkbox">
                                                <input type="checkbox" name="cb_styled" id="checkbox_styled" checked class="form__checkbox__input" />
                                                <label class="form__checkbox__label" htmlFor="checkbox_styled">Dit is een checkbox</label>
                                            </div>
                                        </div>
                                        <div class="form__item--checkbox">
                                            <div class="form__checkbox">
                                                <input type="checkbox" name="cb_styled" id="checkbox_styled" class="form__checkbox__input" />
                                                <label class="form__checkbox__label" htmlFor="checkbox_styled">Dit is ook een checkbox</label>
                                            </div>
                                        </div>
                                        <div class="form__item--checkbox">
                                            <div class="form__checkbox">
                                                <input type="checkbox" name="cb_styled" id="checkbox_styled" class="form__checkbox__input" disabled />
                                                <label class="form__checkbox__label" htmlFor="checkbox_styled" >Disbaled checkbox</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form__item">
                                        <i class="form__icon icons icon-envelope"></i>
                                        <input class="form__input--text" type="email" id="email" />
                                        <label class="form__label">Please enter your E-Mailaddress</label>

                                    </div>

                                    <div class="form__item">
                                        <i class="form__icon icons icon-lock"></i>
                                        <input class="form__input--text" type="password" id="password"/>
                                        <label class="form__label">Please enter your password</label>

                                    </div>

                                    <div class="form__item">
                                        <input class="form__input--text error" type="text"  value="test"/>
                                        <span class="form__error_text">Error description</span>
                                    </div>

                                    <div class="form__item">
                                        <input class="form__input--text" type="text"  disabled/>
                                        <label class="form__label">Disabled text field</label>

                                    </div>

                                    <div class="form__item">
                                        <i class="form__icon icons icon-pencil"></i>
                                        <textarea class="form__input--textarea--dynamic"></textarea>
                                        <label class="form__label">This is a nice input field for a longer description.</label>

                                    </div>

                                    <div class="form__item">
                                        <i class="form__icon icons icon-pencil"></i>
                                        <textarea class="form__input--textarea--dynamic error"></textarea>
                                        <label class="form__label">This is another nice input field for a longer description.</label>
                                        <label class="form__label" htmlFor="quote"> </label>
                                        <span class="form__error_text">Error description</span>

                                    </div>

                                    <!-- SELECT DROPDOWN -->
                                    <div class="form__item">
                                        <i class="form__icon icons icon-location-pin"></i>
                                        <div class="form__select">
                                            <select class="form__input--select">
                                                <option>Pick a location...</option>
                                                <option>Choice 1</option>
                                                <option>Option 2</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="form__item">
                                        <i class="form__icon icons icon-emotsmile"></i>
                                        <div class="form__select">
                                            <select class="form__input--select error">
                                                <option>Pick a location...</option>
                                                <option>Choice 1</option>
                                                <option>Option 2</option>
                                            </select>
                                        </div>
                                        <span class="form__error_text">Error description</span>
                                    </div>

                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form__buttons">
                                        <button type="submit" href="#" class="form__button button--link--cta pull-right">Submit</button>
                                        <a href="#" class="form__button button--link">Cancel</a>
                                    </div>
                                </div>
                            </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2>Breadcrumb</h2>
                    </div>
                    <div class="panel__body">
                        <ul class="breadcrumb">
                            <li><a href="#">Home</a><i class="breadcrumb__icon mdi mdi-chevron-right"></i></li>
                            <li><a href="#">Category</a><i class="breadcrumb__icon mdi mdi-chevron-right"></i></li>
                            <li>Security Design Tool</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2><i class="panel__header__icon icons icon-ghost"></i>Modal</h2>
                    </div>
                    <div class="panel__body">
                        <div class="row">
                            <div class="col-xs-12 col-sm-6">
                                <button class="button--cta" @click="showStyleguideModal">Open modal</button>
                            </div>
                            <div class="col-xs-12 col-sm-6">
                                <button class="button--cta" @click="showStyleguideModalSmall">Open small modal</button>
                            </div>
                            <div class="col-xs-12 col-sm-6">
                                <button class="button--cta" @click="showStyleguideModalBg">Open purple modal</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2><i class="panel__header__icon icons icon-badge"></i>Full Width Table</h2>
                    </div>
                    <div class="panel__body">
                        <div class="panel__sub-header">
                            <h2><i class="panel__header__icon icons icon-briefcase"></i>Subheader</h2>
                        </div>
                        <div class="table__responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th class="table__wrap">Lorem</th>
                                        <th>Ipsum</th>
                                        <th>Status</th>
                                        <th>Sit</th>
                                        <th>Amet</th>
                                        <th class="table__cell--date">Last edit</th>
                                        <th class="table__cell--icon"></th>
                                        <th class="table__cell--icon"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="checkable">
                                            <div class="form__checkbox">
                                                <input type="checkbox" name="cb_styled" id="checkbox_styled" checked class="form__checkbox__input" />
                                                <label class="form__checkbox__label" htmlFor="checkbox_styled"></label>
                                            </div>
                                        </td>
                                        <td class="table__wrap">This is the name of some item in this table</td>
                                        <td>Ipsum</td>
                                        <td>Approved</td>
                                        <td>Sit</td>
                                        <td>Amet</td>
                                        <td>10-11-2017</td>
                                        <td class="table__cell--icon"><span class="table__icon icons icon-pencil"></span></td>
                                        <td class="table__cell--icon"><span class="table__icon icons icon-trash"></span></td>
                                    </tr>
                                    <tr>
                                        <td class="checkable">
                                            <div class="form__checkbox">
                                                <input type="checkbox" name="cb_styled" id="checkbox_styled" class="form__checkbox__input" />
                                                <label class="form__checkbox__label" htmlFor="checkbox_styled"></label>
                                            </div>
                                        </td>
                                        <td class="table__wrap">This is the name of some item in this table</td>
                                        <td>Ipsum</td>
                                        <td>Approved</td>
                                        <td>Sit</td>
                                        <td>Amet</td>
                                        <td>10-11-2017</td>
                                        <td class="table__cell--icon"><span class="table__icon icons icon-pencil"></span></td>
                                        <td class="table__cell--icon"><span class="table__icon icons icon-trash"></span></td>
                                    </tr>
                                    <tr>
                                        <td class="checkable">
                                            <div class="form__checkbox">
                                                <input type="checkbox" name="cb_styled" id="checkbox_styled" checked class="form__checkbox__input" />
                                                <label class="form__checkbox__label" htmlFor="checkbox_styled"></label>
                                            </div>
                                        </td>
                                        <td class="table__wrap">This is another table item</td>
                                        <td>Ipsum</td>
                                        <td>Approved</td>
                                        <td>Sit</td>
                                        <td>Amet</td>
                                        <td>10-11-2017</td>
                                        <td class="table__cell--icon"><span class="table__icon icons icon-pencil"></span></td>
                                        <td class="table__cell--icon"><span class="table__icon icons icon-trash"></span></td>
                                    </tr>
                                    <tr class="table__navigation">
                                        <td colspan="9">
                                            <span>1-20 of 320 items</span>
                                            <div class="table__navigation__pages">
                                                <i class="icons icon-arrow-left left"></i>
                                                <a href="#">1</a>
                                                <a href="#">2</a>
                                                <a href="#">3</a>
                                                <a href="#">4</a>
                                                <i class="icons icon-arrow-right right"></i>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="table__responsive">
                            <table class="table table__responsive table__specified-widths">
                                <thead>
                                <tr>
                                    <th colspan="4">Product</th>
                                    <th colspan="3">Aantal</th>
                                    <th>Prijs per<br/> eenheid</th>
                                    <th>Bedrag</th>
                                    <th class="table__cell--icon"></th>
                                    <th class="table__cell--icon"></th>
                                    <th class="table__cell--icon"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td colspan="4">Product omschrijving</td>
                                    <td colspan="3">1</td>
                                    <td>800,00</td>
                                    <td>800,00</td>
                                    <td><span class="table__icon icons icon-pencil"></span></td>
                                    <td><span class="table__icon icons icon-cloud-download"></span></td>
                                    <td><span class="table__icon icons icon-trash"></span></td>
                                </tr>
                                <tr>
                                    <td colspan="4">Lange product omschrijving</td>
                                    <td colspan="3">1</td>
                                    <td>650,00</td>
                                    <td>650,00</td>
                                    <td><span class="table__icon icons icon-pencil"></span></td>
                                    <td><span class="table__icon icons icon-cloud-download"></span></td>
                                    <td><span class="table__icon icons icon-trash"></span></td>
                                </tr>
                                <tr class="table__navigation">
                                    <td colspan="12">
                                        <pagination :meta="$store.state.invoices.invoicesMeta" @goToPage="goToPage"/>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>



                        <div class="panel__sub-header">
                            <h2><i class="panel__header__icon icons icon-trophy"></i>Subheader</h2>
                        </div>
                        <div class="table__responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th class="table__wrap">Lorem</th>
                                        <th>Ipsum</th>
                                        <th>Status</th>
                                        <th>Sit</th>
                                        <th>Amet</th>
                                        <th class="table__cell--date">Last edit</th>
                                        <th class="table__cell--icon"></th>
                                        <th class="table__cell--icon"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="checkable">
                                            <div class="form__checkbox">
                                                <input type="checkbox" name="cb_styled" id="checkbox_styled" checked class="form__checkbox__input" />
                                                <label class="form__checkbox__label" htmlFor="checkbox_styled"></label>
                                            </div>
                                        </td>
                                        <td class="table__wrap">This is the name of some item in this table</td>
                                        <td>Ipsum</td>
                                        <td>Approved</td>
                                        <td>Sit</td>
                                        <td>Amet</td>
                                        <td>10-11-2017</td>
                                        <td><span class="table__icon icons icon-pencil"></span></td>
                                        <td><span class="table__icon icons icon-trash"></span></td>
                                    </tr>
                                    <tr>
                                        <td class="checkable">
                                            <div class="form__checkbox">
                                                <input type="checkbox" name="cb_styled" id="checkbox_styled" class="form__checkbox__input" />
                                                <label class="form__checkbox__label" htmlFor="checkbox_styled"></label>
                                            </div>
                                        </td>
                                        <td class="table__wrap">This is the name of some item in this table</td>
                                        <td>Ipsum</td>
                                        <td>Approved</td>
                                        <td>Sit</td>
                                        <td>Amet</td>
                                        <td>10-11-2017</td>
                                        <td><span class="table__icon icons icon-pencil"></span></td>
                                        <td><span class="table__icon icons icon-trash"></span></td>
                                    </tr>
                                    <tr>
                                        <td class="checkable">
                                            <div class="form__checkbox">
                                                <input type="checkbox" name="cb_styled" id="checkbox_styled" checked class="form__checkbox__input" />
                                                <label class="form__checkbox__label" htmlFor="checkbox_styled"></label>
                                            </div>
                                        </td>
                                        <td class="table__wrap">This is another table item</td>
                                        <td>Ipsum</td>
                                        <td>Approved</td>
                                        <td>Sit</td>
                                        <td>Amet</td>
                                        <td>10-11-2017</td>
                                        <td><span class="table__icon icons icon-pencil"></span></td>
                                        <td><span class="table__icon icons icon-trash"></span></td>
                                    </tr>
                                    <tr class="table__navigation">
                                        <td colspan="9">
                                            <span>1-20 of 320 items</span>
                                            <div class="table__navigation__pages">
                                                <i class="icons icon-arrow-left left"></i>
                                                <a href="#">1</a>
                                                <a href="#">2</a>
                                                <a href="#">3</a>
                                                <a href="#">4</a>
                                                <i class="icons icon-arrow-right right"></i>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="styleguide__component_block">
                    <div class="styleguide__component_header">
                        <h6>Pagination</h6>
                    </div>
                    <div class="styleguide__component_content">
                        <ul class="pagination">
                            <li class="active"><a href="#">1</a></li>
                            <li><a href="#">2</a></li>
                            <li><a href="#">3</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="styleguide__component_block">
                    <div class="styleguide__component_header">
                        <h6>Tooltips</h6>
                    </div>
                    <div class="styleguide__component_content">
                        <span v-tooltip.top="'This tooltip is positioned at the top!'"><i class="mdi mdi-cursor-pointer"></i> Top tooltip - Hover over me!</span><br />
                        <span v-tooltip.right="'This tooltip is positioned on the right!'"><i class="mdi mdi-cursor-pointer"></i> Right tooltip - Hover over me!</span><br />
                        <span v-tooltip.left="'This tooltip is positioned on the left!'"><i class="mdi mdi-cursor-pointer"></i> Left tooltip - Hover over me!</span><br />
                        <span v-tooltip.bottom="'This tooltip is positioned at the bottom!'"><i class="mdi mdi-cursor-pointer"></i> Bottom tooltip - Hover over me!</span>
                    </div>
                </div>
            </div>
        </div>


        <styleguide-modal></styleguide-modal>
        <styleguide-modal-small></styleguide-modal-small>
        <styleguide-modal-bg></styleguide-modal-bg>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';

    import StyleguideModal from '@/components/modals/styleguide/StyleguideModal';
    import StyleguideModalSmall from '@/components/modals/styleguide/StyleguideModalSmall';
    import StyleguideModalBg from '@/components/modals/styleguide/StyleguideModalBg';
    import LoadingButton from '@/components/general/LoadingButton';

    @Component
    export default class Styleguide extends Vue {
        name = 'styleguide';
        selected = null;

        showStyleguideModal () {
            this.$modal.show('styleguide-modal');
        }

        showStyleguideModalSmall () {
            this.$modal.show('styleguide-modal-small');
        }

        showStyleguideModalBg () {
            this.$modal.show('styleguide-modal-bg');
        }

        expanded = false;

        togglePanelExpansion() {
            this.expanded = !this.expanded;
        }
    }

    Vue.component('styleguide', Styleguide);
</script>




// WEBPACK FOOTER //
// src/pages/Styleguide.vue